export const ALERT_TYPES = {
  LEAD_AVAILABLE_ASSIGNMENT: 'New Lead Available for Assignment',
  INCOMING_COMMUNICATION: 'Incoming Communication',
  LEAD_SHARED: 'Lead Shared',
  ASSIGNED: 'Lead Assigned',
  LEAD_AVAILABLE_CLAIM: 'New Lead Available for Claiming',
};
